module.exports = __webpack_public_path__ + "static/media/kontakt_icn.cc9bba32.svg";